import { ISavedPayerContact } from 'common/types/payerContact.types';

/**
 * Повторные пробелы и пробелы по краям убираются: так имя уходит в start, куку и письмо (US-040, backlog us040-followups).
 * @param {string} value введённая строка
 * @returns {string} строка с одиночными пробелами между словами
 */
export const normalizeSpaces = (value: string): string => value.replace(/\s+/g, ' ').trim();

/**
 * «Имя Фамилия»: минимум два слова после обрезки пробелов (payer-form, R-2).
 * @param {string} value введённое имя
 * @returns {boolean} true, если слов два и больше
 */
export const isFullName = (value: string): boolean => {
  const normalized = normalizeSpaces(value);

  return normalized !== '' && normalized.split(' ').length >= 2;
};

/**
 * Старые ключи localStorage `name` и `surname` одной строкой через пробел, без лишних пробелов (R-5).
 * @param {string | null} name старый ключ `name`
 * @param {string | null} surname старый ключ `surname`
 * @returns {string} одна строка; пустая, если ключей нет
 */
export const joinLegacyName = (name: string | null, surname: string | null): string =>
  normalizeSpaces(`${name ?? ''} ${surname ?? ''}`);

const readSavedField = (value: unknown): string | null => (typeof value === 'string' && value.trim() !== '' ? value : null);

/**
 * Ответ API с сохранёнными контактами: всё, что не непустая строка, читается как null по полю.
 * @param {unknown} body разобранный JSON ответа
 * @returns {ISavedPayerContact} контакты по полям
 */
export const parseSavedPayerContact = (body: unknown): ISavedPayerContact => {
  const record = typeof body === 'object' && body !== null ? (body as Record<string, unknown>) : {};

  return { name: readSavedField(record.name), email: readSavedField(record.email) };
};
